import { array, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as OrganizationId } from '../../../../organization/Id';
//import { Id as UsageId } from '../../../../wholehouse/usage/Id';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
	formula: iotsUtils.NotEmptyString,
	additionalParameters: array(string),
	organizationId: OrganizationId,
});
